import React from "react";

const NavBar = () => {
  return (
    <header>
      <nav>
        <li>DevFinder</li>
      </nav>
    </header>
  );
};

export default NavBar;
